<style lang="less">
.search-api {
    margin-top: 9px
}

.search-api .ivu-input-search {
    font-size: 12px
}

.search-api .ivu-input {
    background: #e4e4e4;
    padding-left: 12px
}

.search-api .ivu-input:focus {
    background: #fff
}

.search-api .ivu-input-group-append {
    cursor: pointer;
    padding: 0 16px!important;
    background: #2d8cf0!important;
    color: #fff!important;
    border-color: #2d8cf0!important;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    position: relative;
    z-index: 2
}
</style>

<template>
  <div class="header-nav">
    <div class="header-container clearfix">
      <h1 class="logo">
        <a href="http://open.baison.net" style="display: flex;align-items: center;height: 100%;">
          <!-- <i class="icon"></i>ME3·开放平台<a href="javascript:void(0)">API文档</a> -->
          <img style="height: 20px;" :src="newlogo">
        </a>
      </h1>
      <ul class="nav">
        <li class="nav-item">
          <router-link to="/">文档中心</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/tool">常用工具</router-link>
        </li>
      </ul>
      <div class="fr search-api">
        <Input v-model="searchValue" placeholder="">
          <div slot="append">
            <Button @click="handleSearch">搜索</Button>
          </div>
        </Input>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/lib/bus.js";
import newlogo from '@/assets/images/20220822.png'
  export default {
    name: "page-header",
    data() {
      return {
        searchValue: '',
        newlogo: newlogo,
      }
    },
    methods: {
      handleSearch: function() {
        let _this = this
        if (_this.searchValue.trim() == '') {
          this.$Message.info('请输入搜索关键词')
          return
        }
        this.$http.get('/api/search?keyword=' + encodeURI(_this.searchValue)).then((res) => {
          // res = {
          //   "status":1,
          //   "data":{
          //       "keyword":"商店",
          //       "menu":[
          //           {
          //             method: "prm.goods.add",
          //             name: "商品档案添加",
          //             path: "prm/goods/add",
          //             firstActive: 0,
          //             secondActive: 0,
          //             thirdActive: 0,
          //           }
          //       ]
          //   },
          //   "message":""
          // }

          if (res.status === 1) {
            bus.$emit('on-search-menu', res.data)
          }
        })
      },
      // 跳转到api调试页面
      gotoTestApiPage: function() {

      }
    }
  }
</script>
